<app-slide id="additionalDetailsSlide" title="Additional Details" supportingText="Please tell us about yourself."
    [slideNumber]="slideNumber" [finalSlide]="finalSlide" [active]="active.active === 'additionalDetails'"
    [slideCompleted]="formState.progress.additionalDetailsComplete">

    <app-spinner *ngIf="loading"></app-spinner>

    <div class="alert alert-danger" *ngIf="errorMessage !== ''">
        {{ errorMessage }}
    </div>
    <!-- {{formState | json}} -->
    <div id="additional-details-error-summary" class="alert alert-danger" *ngIf="errors.length > 0 && showFormErrors">
        <p><strong>Errors found in form</strong></p>
        <p>There is a problem with the form, please check and correct the following, then try and submit it again.</p>
        <ul>
            <li *ngFor="let error of errors">
                <a (click)="scrollToId(error.name)" class="alert-link">{{error.title}}, {{error.msg}}</a>
            </li>
        </ul>
    </div>

    <ng-container *ngIf="fields | async as fields">
        <div>
            <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
            <div class="section ng-empty" *ngIf="showSubmit">
                <div class="row">
                    <div class="col-sm-8">
                    </div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <button type="submit" class="btn btn-primary" style="position: relative;"
                                (click)="onSubmit()" (disabled)="isDisabled">
                                <span>Save &amp; Continue Securely</span>
                                <app-spinner *ngIf="submitting" class="signupSubmitSpinner"></app-spinner>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</app-slide>